import { loadingBarReducer } from "react-redux-loading-bar";
import { reducer as toastrReducer } from "react-redux-toastr";
import { combineReducers } from "redux";

import {
  authUserReducer,
  sourceOfBusinessReducer,
  initialTouchPointReducer,
  buyingInfluenceReducer,
  leadIntentReducer,
  leadNewnessReducer,
  leadStatusReducer,
  leadTypeReducer,
  leadSourceReducer,
  uiDataReducer,
  LeadReducer,
  appSettingsReducer,
  lead360Reducer,
  masterDataReducer,
  logReducer,
  shortListPopertyReducer,
  dashboadSearchReducer,
  compareReducer,
} from "./reducers";
import { State } from "./interfaces";
import { configurationReducer } from "./reducers/configuration";
import { decisionTimeFrameReducer } from "./reducers/decisionTimeFrame";

export const rootReducer = combineReducers<State>({
  authUser: authUserReducer,
  toastr: toastrReducer,
  loadingBar: loadingBarReducer,
  leadIntent: leadIntentReducer,
  leadType: leadTypeReducer,
  leadStatus: leadStatusReducer,
  leadNewness: leadNewnessReducer,
  decisionTimeFrame: decisionTimeFrameReducer,
  sourceOfBusiness: sourceOfBusinessReducer,
  initialTouchPoint: initialTouchPointReducer,
  buyingInfluence: buyingInfluenceReducer,
  leadSource: leadSourceReducer,
  uiData: uiDataReducer,
  masterData: masterDataReducer,
  lead: LeadReducer,
  configuration: configurationReducer,
  lead360: lead360Reducer,
  appSettings: appSettingsReducer,
  log: logReducer,
  compareReducer,
  shortListPoperty: shortListPopertyReducer,
  dashboard: dashboadSearchReducer,
});
